import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { PartnerDeliveryConfig } from '../redux/types'
import { updatePartnerDeliveryConfig, deletePartnerDeliveryConfig } from '../redux/actions'
import { inputMaskMoney } from 'util/masks'

const DeliveryItem: React.FC<{ partnerId: number, item: PartnerDeliveryConfig }> = ({ partnerId, item }) => {
  const simbol = item.type === 'PRICE_BY_DISTANCE' ? 'Km' : 'R$'

  const dispatch = useDispatch()
  const [form, setForm] = useState(item)
  const [masked, setMasked] = useState({ min: `${simbol} 0,00`, max: `${simbol} 0,00`, price: 'R$ 0,00' })

  useEffect(() => {
    const [min] = inputMaskMoney(item.min, simbol)
    const [max] = inputMaskMoney(item.max, simbol)
    const [price] = inputMaskMoney(item.price, 'R$')
    setMasked({ min, max, price })
  }, [item, simbol])

  function handleUpdate (e: React.FocusEvent<HTMLInputElement>): void {
    e.preventDefault()
    updatePartnerDeliveryConfig(partnerId, item.id, form)(dispatch)
  }

  function handleRemove (): void {
    deletePartnerDeliveryConfig(partnerId, item.id)(dispatch)
  }

  return (
    <div className="row delivery-item align-center">
      <span className="trash-circle-btn button" onClick={handleRemove}>
        <i style={{ color: '#7B7B7B' }} className="fas fa-trash"></i>
      </span>

      <input
        type="text"
        value={masked.min}
        onChange={(e): void => {
          const [str, min] = inputMaskMoney(e.target.value, simbol)
          setForm({ ...form, min })
          setMasked({ ...masked, min: str })
        }}
        onBlur={handleUpdate}
      />
      <p style={{ width: 30, textAlign: 'center' }}>~</p>
      <input
        type="text"
        value={masked.max}
        onChange={(e): void => {
          const [str, max] = inputMaskMoney(e.target.value, simbol)
          setForm({ ...form, max })
          setMasked({ ...masked, max: str })
        }}
        onBlur={handleUpdate}
      />
      <p style={{ width: 30, textAlign: 'center' }}>=</p>
      <input
        type="text"
        value={masked.price}
        onChange={(e): void => {
          const [str, price] = inputMaskMoney(e.target.value, 'R$')
          setForm({ ...form, price })
          setMasked({ ...masked, price: str })
        }}
        onBlur={handleUpdate}
      />
    </div>
  )
}

export default DeliveryItem
